// @ts-nocheck
import {
  cleanText,
  createCommissionTemplate,
  isCommissionMergedPriceSubRow,
} from './commissionTemplateHelpers.js';

/** A열(번호) 없음 = 약가 서브행·구분 행 등 본품이 아님 */
function shouldSkipKukjePharmDataRow(row = [], columnMap = {}) {
  if (isCommissionMergedPriceSubRow(row, columnMap)) {
    return true;
  }

  return cleanText(row?.[0]) === '';
}

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '국제약품',
  targetSheetName: '국제약품',
  headerRowIndex: 6,
  headerRowCount: 1,
  dataStartRowIndex: 8,
  requiredHeaders: [
    '제품명',
    '성분 . 함량',
    'KD코드',
    '포장단위',
    '요율',
    '비고',
  ],
  columnMapping: {
    drugName: '제품명',
    drugCode: 'KD코드',
    commissionRate: '요율',
    commissionNote: '비고',
  },
  // 헤더는 0열=제품명이지만 데이터는 0열=번호, 1열=제품명 (병합 셀)
  columnIndexOverrides: {
    drugName: 1,
    drugCode: 11,
    commissionRate: 22,
  },
  mergePriceFromFollowingSubRow: true,
  shouldSkipDataRow: shouldSkipKukjePharmDataRow,
});
